import React, { Component } from 'react'
import { WP_URL } from '../wp-url'
import fetch from 'isomorphic-fetch'
import _ from 'lodash'
import { TransitionGroup } from 'react-transition-group'
import cn from 'classnames'
import { Fade, FadeAbsolute2 } from './Transitions'
import ReactHtmlParser from 'react-html-parser'

export default class ContactForm extends Component {
	constructor(props) {
	    super(props)
	    this.state = {
	    	formContent: {
	    		userFieds: [],
	    		textField: '',
	    		checkboxFields: [],
	    	},
	    	name: '',
	    	nameValid: '',
	    	email: '',
	    	emailValid: '',
	    	telephone: '',
	    	telephoneValid: '',
	    	selectedTrainings: [props.selected],
	    	comments: '',
	    	messageSent: false,
	    	messageError: '',
	    	sending: false,
	    }

	    this.handleChange = this.handleChange.bind(this)
	    this.handleCheck = this.handleCheck.bind(this)
	    this.handleSubmit = this.handleSubmit.bind(this)
	    // this.transformNode = this.transformNode.bind(this)
	}
	handleChange(value, e) {
    	this.setState({ [value]: e.target.value })
    	if (value === 'email') {
    		const validEmail = this.validateMail(e.target.value)
    		this.setState({
    			emailValid: validEmail
    		})
    	}
    	else if (value === 'name') {
    		this.setState({
    			nameValid: e.target.value.length > 3
    		})
    	}
    	else if (value === 'telephone'){
    		this.setState({
    			telephoneValid: e.target.value.length > 10
    		})
    	}
	}
	// createFormNodes(node) {
	// 	if (node.type === 'tag' && node.name === 'input') {
	//     	if (node.attribs.type === 'tel' || node.attribs.type === 'email' || node.attribs.type === 'text' || node.attribs.type === 'checkbox') {
	// 			return {value: node.attribs.value, type: node.attribs.type, name: node.attribs.name}
	// 	    }
	//     }
	//     if (node.type === 'tag' && node.name === 'textarea') {
	// 		return {value: node.children[0].data, name: node.attribs.name}
	//     }
	// }
	// transformNode(node) {
	// 	const handleChange = this.handleChange
	// 	console.log(node)
	//     if (node.type === 'tag' && node.name === 'input') {
	//     	if (node.attribs.type === 'tel' || node.attribs.type === 'email' || node.attribs.type === 'text') {
	// 			return <Input label={node.attribs.value} type={node.attribs.type} name={node.attribs.name} onChange={this.handleChange} value={this.state.name} />
	// 	    }
	// 	    if (node.attribs.type === 'checkbox') {
	// 			return <Checkbox label={node.attribs.value} name={node.attribs.value} onCheck={this.handleCheck} selected=""/>
	// 	    }
	// 	    if (node.attribs.type === 'submit') {
	// 			return null
	// 	    }
	//     }
	//     if (node.type === 'tag' && node.name === 'textarea') {
	// 		return <Textarea label={node.children[0].data} rows={10} name={node.attribs.name} onChange={this.handleChange} value={this.state.comments} />
	//     }
	//     if ( node.type === 'tag' && (node.name === 'br')) {
	//     	return null
	//     }

	// }
	handleCheck(name) {
		const selectedTrainings = this.state.selectedTrainings.includes(name) ? this.state.selectedTrainings.filter(training => name !== training) : [...this.state.selectedTrainings, name]
		this.setState({
			selectedTrainings: selectedTrainings,
		})
	}
	validateMail(email) {
		let regEx = /^[a-zA-Z0-9.!#$%&'*+=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
		return regEx.test(email)
	}
	handleSubmit(e) {
		e.preventDefault()
		if(!this.state.emailValid || !this.state.nameValid || !this.state.telephoneValid) {
			return false
		}
		const payload = {
		    'naam': this.state.name,
		    'email': this.state.email,
		    'telephone': this.state.telephone,
		    'comments': this.state.comments,
		    'check-training': this.state.selectedTrainings,
		}
		this.setState({
			sending:true,
		})
		var data = new FormData()
		_.forOwn(payload, (value, key) => { data.append(key, value) } )

		//for cf7
		// data.append('_wpcf7_nonce','1e2a853ad1')

		fetch(WP_URL + '/contact-form-7/v1/contact-forms/'+this.props.formId+'/feedback', {
			method: 'POST',
			body: data,
			processData: false,
			contentType: false,
			credentials: 'same-origin',
		})
		.then(response => response.json())
        .then(message => {
        	console.log(message)
        	this.setState({
				sending:false,
			})
        	if (message.status !== 'mail_sent') {
        		this.setState({messageError: message.message})
        	}
        	else {
        		this.setState({messageSent: true})
        	}
        })
	}
	// componentWillMount() {
 //        document.getElementsByTagName("body")[0].style.overflow = "hidden"
	// }
	// componentWillUnmount(){
 //        document.getElementsByTagName("body")[0].style.overflow = "auto"
 //    }
	render() {
		const nameClass = cn({invalid: !this.state.nameValid && this.state.name.length > 0, valid: this.state.nameValid})
		const emailClass = cn({invalid: !this.state.emailValid && this.state.email.length > 0, valid: this.state.emailValid})
		const telephoneClass = cn({invalid: !this.state.telephoneValid && this.state.telephone.length > 0, valid: this.state.telephoneValid})
		const { trainingen } = this.props

		const train1 = trainingen.slice(0, Math.ceil(trainingen.length/2))
		const train2 = trainingen.slice(Math.ceil(trainingen.length/2))

		return (
			<TransitionGroup className="absolute-wrapper">
				{ this.state.messageSent ?
					<FadeAbsolute2 key="1">
						<p>Bedankt voor je aanvraag! We komen zo snel mogelijk bij je terug.</p>
					</FadeAbsolute2>
					:
					<Fade key="2">
						<form className="form" onSubmit={this.handleSubmit} key="2">
							<Textarea label='Vraag of opmerking' rows={3} name="comments" onChange={this.handleChange} value={this.state.comments} />

							<h5>Kies je trainingen (optioneel)</h5>
							<div className="selection-wrap grid-x grid-margin-x">
								<div className="cell small-12 medium-6">
									{train1.map( (item, i) => 
										<Checkbox key={i} label={item.title.rendered} name={item.slug} onCheck={this.handleCheck} selected={this.state.selectedTrainings.includes(item.slug)}/>
									)}
								</div>
								<div className="cell small-12 medium-6">
									{train2.map( (item, i) => 
										<Checkbox key={i} label={item.title.rendered} name={item.slug} onCheck={this.handleCheck} selected={this.state.selectedTrainings.includes(item.slug)}/>
									)}
								</div>
							</div>

							<h5>Vul je gegevens in</h5>
							<Input label='Naam' type="text" name="name" onChange={this.handleChange} value={this.state.name} className={nameClass}/>
							<Input label='Email' type="email" name="email" onChange={this.handleChange} value={this.state.email} className={emailClass}/>
							<Input label='Telefoon' type="tel" name="telephone" onChange={this.handleChange} value={this.state.telephone} className={telephoneClass}/>
							<Submit value={this.state.sending ? 'Bezig...' : 'Verstuur'} disabled={!this.state.emailValid || !this.state.nameValid || !this.state.telephoneValid || this.state.sending}/>
							
							<TransitionGroup>
							{this.state.messageError !== '' && 
								<Fade>
									<div className="error">{ReactHtmlParser(this.state.messageError)}</div>
								</Fade>
							}
							</TransitionGroup>
						</form> 
					</Fade>
				}
			</TransitionGroup>
		)
	}
}

const Input = (props) => {
	return (
		<div className="input">
			{props.label && <label>{ReactHtmlParser(props.label)}</label>}
			<input type={props.type} value={props.value} onChange={props.onChange.bind(this, props.name)} className={props.className}/>
		</div>
	)
}

const Textarea = (props) => {
	return (
		<div className="textarea">
			{props.label && <h5>{ReactHtmlParser(props.label)}</h5>}
			<textarea rows={props.rows} value={props.value} onChange={props.onChange.bind(this, props.name)} className={props.className}/>
		</div>
	)
}

const Submit = (props) => {
	return (
		<div>
			<input type="submit" value={props.value} disabled={props.disabled} className="button large"/>
		</div>
	)
}

const Checkbox = (props) =>
	<div className="toggle" onClick={props.onCheck.bind(this, props.name)}>
        <div className="switch tiny">
          <input className="switch-input" id={props.name} type="checkbox" name={props.name} checked={props.selected} readOnly/>
          <label className="switch-paddle" htmlFor={props.name} />
        </div>
        {ReactHtmlParser(props.label)}
    </div>


// WEBPACK FOOTER //
// ./src/components/ContactForm.js